<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="transparent"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.52 10.52C4.91176 10.52 6.04 9.39174 6.04 7.99998C6.04 6.60822 4.91176 5.47998 3.52 5.47998C2.12824 5.47998 1 6.60822 1 7.99998C1 9.39174 2.12824 10.52 3.52 10.52Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />

  <path
    d="M12.48 15C13.8717 15 15 13.8717 15 12.48C15 11.0882 13.8717 9.95996 12.48 9.95996C11.0882 9.95996 9.95996 11.0882 9.95996 12.48C9.95996 13.8717 11.0882 15 12.48 15Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />

  <path
    d="M12.48 6.04C13.8717 6.04 15 4.91176 15 3.52C15 2.12824 13.8717 1 12.48 1C11.0882 1 9.95996 2.12824 9.95996 3.52C9.95996 4.91176 11.0882 6.04 12.48 6.04Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />

  <path
    d="M5.76001 6.87989L10.24 4.63989M5.76001 9.11989L10.24 11.3599L5.76001 9.11989Z"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
